import React, { lazy, createElement } from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// PERFORMANCE: Inject critical resource hints synchronously BEFORE React mounts.
// This ensures the browser starts the connection + image download as early as possible.
if (typeof document !== 'undefined') {
  const head = document.head;
  if (!document.querySelector('link[rel="preconnect"][href*="cdn.magicpatterns"]')) {
    const preconnect = document.createElement('link');
    preconnect.rel = 'preconnect';
    preconnect.href = 'https://cdn.magicpatterns.com';
    preconnect.crossOrigin = 'anonymous';
    head.appendChild(preconnect);
  }
  if (!document.querySelector('link[rel="dns-prefetch"][href*="cdn.magicpatterns"]')) {
    const dnsPrefetch = document.createElement('link');
    dnsPrefetch.rel = 'dns-prefetch';
    dnsPrefetch.href = 'https://cdn.magicpatterns.com';
    head.appendChild(dnsPrefetch);
  }
  // Preload the LCP hero image so the browser starts downloading before React renders
  const heroImg = 'https://cdn.magicpatterns.com/uploads/7EYMj6MZzTYg5opvzc8sU6/Diseno_sin_titulo_(6).webp';
  if (!document.querySelector(`link[rel="preload"][href="${heroImg}"]`)) {
    const preload = document.createElement('link');
    preload.rel = 'preload';
    preload.as = 'image';
    preload.href = heroImg;
    preload.setAttribute('fetchpriority', 'high');
    head.appendChild(preload);
  }
}
// PERFORMANCE: Static import of createRoot (no extra network roundtrip vs dynamic import).
// React 18 concurrent rendering = faster mount.
const rootEl = document.getElementById('root')!;
createRoot(rootEl).render(<App data-id="element-460" />);
// PERFORMANCE: After the page is interactive, prefetch lazy chunks in idle time
// so scrolling and CTA clicks feel instant (chunks already in browser cache).
if (typeof window !== 'undefined') {
  const prefetchLazy = () => {
    import('./components/TomosSection').catch(() => {});
    import('./components/BonusSection').catch(() => {});
    import('./components/PricingSection').catch(() => {});
    import('./components/IsForYouSection').catch(() => {});
    import('./components/TestimonialsSection').catch(() => {});
    import('./components/GuaranteeSection').catch(() => {});
    import('./components/FAQSection').catch(() => {});
    import('./components/UpsellSection').catch(() => {});
    import('./components/CostOfNotHavingItSection').catch(() => {});
    import('./components/Footer').catch(() => {});
  };
  if ('requestIdleCallback' in window) {
    ;
    (window as any).requestIdleCallback(prefetchLazy, {
      timeout: 4000
    });
  } else {
    setTimeout(prefetchLazy, 2500);
  }
}